import { Credential } from "../services/models/Credential";
import { Organization } from "../services/models/Organization";
import { Revision } from "../services/models/Revision";

export default class Data {
    static getAppTypes = () => {
        return {
            EITRI_TYPE_FRAME: "EITRI_FRAME",
            EITRI_TYPE_ENGINE: "EITRI_ENGINE"
        };
    };

    static getMiniAppStatus = () => {
        return {
            STATUS_ACTIVE: "ACTIVE",
            STATUS_INACTIVE: "INACTIVE"
        };
    };

    static getRolloutStatus = () => {
        return {
            STATUS_ENABLED: "ENABLED",
            STATUS_DISABLED: "DISABLED"
        };
    };

    static getEditMiniAppSchemas = () => {
        return [
            "id",
            "name",
            "title",
            "icon",
            "walletToken",
            "slug",
            "parentSlug",
            "type",
            "visible",
            "status",
            "permissions"
        ];
    };

    static getMiniAppPayload = (
        credentialVO: Credential,
        revisions: Revision[],
        image: string,
        organizationVO: Organization
    ) => {
        return {
            id: "",
            name: "",
            title: "",
            icon: image,
            slug: "",
            type: "-",
            status: "INACTIVE",
            visible: false,
            permissions: [],
            revisions: revisions,
            credential: credentialVO,
            organization: organizationVO,
            privacy: { mode: "" }
        };
    };

    static getAdviceTextFromInputs = () => {
        return {
            name:
                "(É permitido apenas: letras com ou sem acento, números, espaço, ponto (.), sinal (+ e -) e quebra de linha)",
            title:
                "(É permitido apenas: letras com ou sem acento, números, espaço, ponto, + e -)",
            slug:
                "(É permitido apenas: letras sem acento, números, hífen(-), underline(_) e ponto(.))",
            walletToken:
                "(É permitido apenas: letras sem acento, números e hífen (-))"
        };
    };

    static getOnBoardindOptions = () => {
        return {
            default: { NAME: "no_value", VALUE: "SELECIONE UMA OPÇÃO" },
            unrestricted: { NAME: "UNRESTRICTED", VALUE: "SEM RESTRIÇÕES" },
            beforeOpen: {
                NAME: "ACCEPT_TERMS_BEFORE_OPEN",
                VALUE: "ACEITAR OS TERMOS ANTES DE ABRIR"
            },
            beforeTransaction: {
                NAME: "ACCEPT_TERMS_BEFORE_TRANSACTION",
                VALUE: "ACEITAR OS TERMOS ANTES DA TRANSAÇÃO"
            }
        };
    };
}
